import { nullToUndefined } from "../../../helper/nullToUndefined";

export interface PlaylistItemDTO {
  songId?: string;
  title?: string;
  note?: string;
}

export class PlaylistItemDTOCompanion {
  public static fromParsedJson(
    playlistItems: ReadonlyArray<PlaylistItemDTO>,
  ): ReadonlyArray<PlaylistItemDTO> {
    return playlistItems.flatMap((i: PlaylistItemDTO) => {
      const songId = nullToUndefined(i.songId);
      const title = nullToUndefined(i.title);
      const note = nullToUndefined(i.note);

      return songId || title || note ? [{ songId, title, note }] : [];
    });
  }
}
